// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"VideoIframe_videoWrapper__9GGcm","iframe":"VideoIframe_iframe__1_v3Z"};